import { Component, ElementRef, Inject, Input, OnDestroy, OnInit, ViewChild, } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DepotService, AssetTypeClassification, LocationTypeDto, CurrentAssetLocationDto, CustomerLocationDto, ContainerAvailabilityService, ContainerAvailabilityResponse, ContainerStatus, ContainerAvailabilityShow, LocationDetailsService, AssetDamageHistoryDto, AssetDamageService } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import moment from 'moment';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable, of } from 'rxjs';
import { startWith } from 'rxjs/operators';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';
import { SummaryDataItemModel } from '../models/summary-data-item-model';
import { GeoHelper } from '../helpers/geo';
import { LocationClassNameHelper } from '../enums/LocationTypeNames';
import { AssetOnSiteModel } from '../location-detail/assets-on-site-model';

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

export enum DamageStatus {
  None = 0,
  InService = 1,
  Damaged = 2,
  DamagedInService = 3
}

export enum ShowSetting {
  All = 0,
  Surplus = 1,
  Deficit = 2
}

export enum DamageContainerStatus {
  InService = 0,
  Damaged = 1,
  DamagedInService = 2
}

@Component({
    selector: 'app-depot-details-component',
    templateUrl: './depot-details.component.html',
    styleUrls: ['./depot-details.component.scss'],
    standalone: false
})
export class DepotDetailsComponent extends PagebaseComponent implements OnDestroy, OnInit {
  @Input() depotId!: string;
  @Input() locationId!: string;
    
  // Private variables
  customerId: string;
  data: ContainerAvailabilityResponse;
  regionList: DropDownListItem[] = [];
  allDepots: DropDownListItem[] = [];
  depotList: DropDownListItem[] = [];
  locationList: DropDownListItem[] = [];
  containerList: DropDownListItem[] = [];
  typeList: DropDownListItem[] = [];
  statusList: DropDownListItem[] = [];
  selectedRegionId: string;
  selectedDepotId: string;
  selectedLocationId: string = null;
  selectedVehicleType: string;
  selectedDamageStatus: string;
  selectedShowSetting: string;
  selectedContainerId: string;
  selectedContainerTypeId: string;
  selectedStatusId: string;
  currentFilter: string;
  assetTypeSearchControl: UntypedFormControl = new UntypedFormControl();
  expandedCategories: string[] = [];
  expandedDamage: string[] = [];
  searchControl: UntypedFormControl = new UntypedFormControl();
  locationTypes: LocationTypeDto[];
  locationTypesDisplay: LocationTypeDto[] = [];  
  isPopupOpen = false;
  selectedImage: string | null = null;
  summaryData = [];
  locations: CustomerLocationDto[];
  assets: CurrentAssetLocationDto[];
  totalDepot: number = 0;
  totalYard: number = 0;
  totalDamaged: number = 0;
  totalAvailable: number = 0;
  totalRequired: number = 0;
  totalSurplus: number = 0;
  totalDeficit: number = 0;
  totalNetSurplus: number = 0;
  private apiCall;

  // Public variables
  DamageStatus = DamageStatus;
  ShowSetting = ShowSetting;
  loading: boolean = true;
  containersLoaded: boolean = false;
  filtersLoaded: boolean = false;
  availabilityLoaded: boolean = false;
  damageLoaded: boolean = false;
  isAdmin: boolean = false;
  assetsOnSite: AssetOnSiteModel[] = [];
  filteredAssetsOnSite: AssetOnSiteModel[] = [];
  damage: AssetDamageHistoryDto[];
  
  // Constuctor
  constructor(
    private containerAvailabilityService: ContainerAvailabilityService,
    private depotService: DepotService,
    private locationDetailsService: LocationDetailsService,
    private assetDamageService: AssetDamageService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Depot");

    if (!this.depotId) {
      this.sessionStorageService.removeItem("depot-details-selectedDepotId");
    }

    if (!this.locationId) {
      this.sessionStorageService.removeItem("depot-details-selectedLocationId");
    }
  }

  ngOnInit() {
    this.authService.isAdmin().then(result => {
      this.isAdmin = result;
    })
    this.summaryData = this.getLoadingSummarries();
  }

  ngOnDestroy(): void {
  }

  getLoadingSummarries() : SummaryDataItemModel[] {
    var items = [];
    var text = "";
    text = text.concat("\xa0");
    let blank: SummaryDataItemModel = {
      Title: text,
      Value: text
    };
    items.push(blank);
    items.push(blank);
    items.push(blank);
    items.push(blank);
    return items;
  }

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.data = null;
    this.locations = [];
    this.assets = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  // Get the view data
  async getData() {
    this.data = null;
    this.loading = true;

    this.setIsLoading(this.loading);

    this.filtersLoaded = false;
    this.availabilityLoaded = false;
    this.damageLoaded = false;

    if (!this.depotId && !this.locationId) {
      this.locationId = await this.depotService.getUserLocationId(this.pageHelperService.selectedCompanyId, this.depotId).toPromise();
    }
    
    if (this.depotId) {
      this.sessionStorageService.setItem("depot-details-selectedDepotId", this.depotId);
      this.sessionStorageService.removeItem("depot-details-selectedRegionId");
      this.sessionStorageService.removeItem("depot-details-selectedLocationId");
      this.sessionStorageService.removeItem("depot-details-selectedDamageStatus");
      this.sessionStorageService.removeItem("depot-details-selectedShowSetting");
      this.depotId = null;
    }

    if (this.locationId) {
      this.sessionStorageService.setItem("depot-details-selectedLocationId", this.locationId);
      this.locationId = null;
    }

    let selectedRegionId = this.sessionStorageService.getItem("depot-details-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }
    else {
      this.selectedRegionId = null;
    }
    let selectedDepotId = this.sessionStorageService.getItem("depot-details-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    else {
      this.selectedDepotId = null;
    }
    let selectedLocationId = this.sessionStorageService.getItem("depot-details-selectedLocationId");
    if(selectedLocationId) {
      this.selectedLocationId = selectedLocationId;
    }
    else {
      this.selectedLocationId = null;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }
    let selectedDamageStatus = this.sessionStorageService.getItem("depot-details-selectedDamageStatus");
    if(selectedDamageStatus) {
      this.selectedDamageStatus = selectedDamageStatus;
    }    
    let selectedShowSetting = this.sessionStorageService.getItem("depot-details-selectedShowSetting");
    if(selectedShowSetting) {
      this.selectedShowSetting = selectedShowSetting;
    }
    
    this.getContainers();

    if(this.customerId != this.pageHelperService.selectedCompanyId) {
      console.log("loading regions & depots");

      this.customerId = this.pageHelperService.selectedCompanyId;
      this.depotService.getRegions(this.pageHelperService.selectedCompanyId).subscribe(data => {
        const regionList: DropDownListItem[] = [];
        data.forEach(region => {
          let regionItem = new DropDownListItem()
          regionItem.id = region.id;
          regionItem.name = region.name;
          regionList.push(regionItem)
        });
        
        this.regionList = regionList;
        this.depotService.getUserDepots(this.pageHelperService.selectedCompanyId).subscribe(data => {    
          const depotList: DropDownListItem[] = [];
          data.forEach(depot => {
            let depotItem = new DropDownListItem()
            depotItem.id = depot.id;
            depotItem.name = depot.name;
            depotList.push(depotItem)
          });
          
          this.allDepots = depotList;
          this.depotList = depotList;
          this.filtersLoaded = true;
          if (this.containersLoaded && this.filtersLoaded && this.availabilityLoaded && this.damageLoaded) {
            this.loading = false;
            this.setIsLoading(this.loading);
          }
        });
      });
    }
    else {
      this.filtersLoaded = true;
      if (this.containersLoaded && this.filtersLoaded && this.availabilityLoaded && this.damageLoaded) {
        this.loading = false;
        this.setIsLoading(this.loading);
      }
    }

    this.apiCall = this.containerAvailabilityService
      .getContainerAvailability(
        this.customerId,
        this.getRegionId(selectedRegionId),
        this.getDepotId(selectedDepotId),
        this.getLocationId(selectedLocationId),
        this.getDamageStatus(selectedDamageStatus),
        this.getShowSetting(selectedShowSetting),
        this.getAssetTypeClassification(selectedVehicleType),
        null,
        false)
      .subscribe(data => {
        this.data = data;
        
        if (this.data.regionDepotIds && this.data.regionDepotIds.length > 0) {
          this.depotList = this.allDepots.filter(item => this.data.regionDepotIds.includes(item.id));
        }
        else {
          this.depotList = this.allDepots;
        }
        this.assets = data.assets;
        this.locations = data.locations;
        this.locationList = this.locations.map(l => <DropDownListItem>{ id: l.id, name: l.displayName });
        this.locationTypes = data.locationTypes;
        this.showAssets();
        this.availabilityLoaded = true;
        if (this.containersLoaded && this.filtersLoaded && this.availabilityLoaded && this.damageLoaded) {
          this.loading = false;
          this.setIsLoading(this.loading);
        }   
      }, error => {
        debugger;
      });

      this.assetDamageService.getDamage(this.customerId, this.getLocationId(selectedLocationId), this.getAssetTypeClassification(selectedVehicleType)).subscribe(data => {
        this.damage = data;
        this.damageLoaded = true;
        if (this.containersLoaded && this.filtersLoaded && this.availabilityLoaded && this.damageLoaded) {
          this.loading = false;
          this.setIsLoading(this.loading);
        }     
      }, error => {
        debugger;
      });

      console.log("done")
  }

  private getContainers() {
    this.containersLoaded = false;

    if (!this.selectedLocationId) {
      this.selectedLocationId = this.locationId;
    }

    if (this.selectedLocationId) {
      this.locationId = this.selectedLocationId;
      this.locationDetailsService.getLocationDetails(this.selectedLocationId, this.pageHelperService.selectedCompanyId, true).subscribe(data => {
        let locationName = data?.location?.displayName;
        this.pageHelperService.setPageTitle(locationName ?? "Depot");
        this.addContainerLists(data.assetsOnSite);
        let assetsOnSite = data.assetsOnSite?.filter(a =>
          ((!this.currentFilter || this.currentFilter == "Depot")
            || (this.currentFilter == "Yard" && a.isYardBin)
            || (this.currentFilter == "Damaged" && a.damagedDate && !a.responseDate)
            || (this.currentFilter == "Available" && !a.isYardBin && !(a.damagedDate && !a.responseDate)))
            && ((!this.selectedVehicleType || this.selectedVehicleType == "All")
              || (a.assetTypeClassification == AssetTypeClassification.RoRo && this.selectedVehicleType == "RoRo")
              || (a.assetTypeClassification == AssetTypeClassification.Skip && this.selectedVehicleType == "Chain Lift")))
          .sort(function (a, b) {
            return b.daysAtLocation - a.daysAtLocation;
          })
          .map(a => new AssetOnSiteModel(a));

        this.filterClientSide(assetsOnSite)

        this.containersLoaded = true;
        if (this.containersLoaded && this.filtersLoaded && this.availabilityLoaded && this.damageLoaded) {
          this.loading = false;
          this.setIsLoading(this.loading);
        }
      });
    }
    else {
      this.containersLoaded = true;
      if (this.containersLoaded && this.filtersLoaded && this.availabilityLoaded && this.damageLoaded) {
        this.loading = false;
        this.setIsLoading(this.loading);
      }
    }
  }

  filterClientSide(assetsOnSite: AssetOnSiteModel[]) {
    if (assetsOnSite) {
      this.assetsOnSite = assetsOnSite;
    }
    
    
    let filteredAssetsOnSite = this.assetsOnSite;

    if(this.selectedContainerId) {
      filteredAssetsOnSite = filteredAssetsOnSite.filter(a => a.id == this.selectedContainerId)
    }
    if(this.selectedContainerTypeId) {
      filteredAssetsOnSite = filteredAssetsOnSite.filter(a => a.type == this.selectedContainerTypeId)
    }
    if(this.selectedStatusId) {
      console.log(this.selectedStatusId)
      console.log(filteredAssetsOnSite)
      filteredAssetsOnSite = filteredAssetsOnSite.filter(a => ContainerStatus[a.containerStatus] == this.selectedStatusId)
    }

    this.filteredAssetsOnSite = filteredAssetsOnSite;
  }

  addContainerLists(assets: CurrentAssetLocationDto[]) {
    var containerList: DropDownListItem[] = []
    var assetTypeList: DropDownListItem[] = []
    var statusList: DropDownListItem[] = []
    assets.forEach(asset => {
      let containerItem = new DropDownListItem()
      containerItem.id = asset.id;
      containerItem.name = asset.id;
      containerList.push(containerItem)

      if (!assetTypeList.find(a => a.id == asset.assetType)) {
        let typeItem = new DropDownListItem()
        typeItem.id = asset.assetType;
        typeItem.name = asset.assetType;
        assetTypeList.push(typeItem)
      }

      if (!statusList.find(a => a.id == asset.containerStatus.toString())) {
        let statusItem = new DropDownListItem()
        statusItem.id = asset.containerStatus.toString();
        statusItem.name = this.splitByCapitalLetters(ContainerStatus[asset.containerStatus]);
        statusList.push(statusItem)
      }
    });

    containerList = containerList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    assetTypeList = assetTypeList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    statusList = statusList.sort(function(a, b){
      if(a.name < b.name) { return -1; }
      if(a.name > b.name) { return 1; }
      return 0;
    })

    this.containerList = containerList;
    this.typeList = assetTypeList;
    this.statusList = statusList;
  }

  getBinsAtLocation(locationId: string) : CurrentAssetLocationDto[]{
    if (!this.assets) {
      return [];
    }

    return this.assets.filter(a => a.locationId == locationId);
  }

  getLocation(locationId: string) : CustomerLocationDto{
    return this.locations.find(a => a.id == locationId);
  }

  showAssets() {
    let selectedAssetLocationTypeId = this.sessionStorageService.getItem("depot-details-selectedAssetLocationTypeId");
    let selectedRegionId = this.sessionStorageService.getItem("depot-details-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }    
    let selectedDepotId = this.sessionStorageService.getItem("depot-details-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }

    this.totalDepot = this.data.depotTotal;
    this.totalYard = this.data.yardTotal;
    this.totalDamaged = this.data.damagedTotal;
    this.totalAvailable = this.data.availableTotal;
    this.totalRequired = this.data.requiredTotal;
    this.totalSurplus = this.data.surplusTotal;
    this.totalDeficit = this.data.deficitTotal;
    this.totalNetSurplus = this.data.netSurplusTotal;
    this.summaryData = this.getSummaryData();
  }

  getSummaryData(): SummaryDataItemModel[] {
    let items = [];

    let depot: SummaryDataItemModel = {
      Title: "Depot" + (this.currentFilter == "Depot" && this.locationId ? ' *' : ''),
      Value: this.totalDepot.toString(),
      OnClick: () => this.filterContainers("Depot")
    };
    items.push(depot);

    let yard: SummaryDataItemModel = {
      Title: "Yard" + (this.currentFilter == "Yard" && this.locationId ? ' *' : ''),
      Value: this.totalYard.toString(),
      OnClick: () => this.filterContainers("Yard")
    };
    items.push(yard);

    let damaged: SummaryDataItemModel = {
      Title: "Damaged" + (this.currentFilter == "Damaged" && this.locationId ? ' *' : ''),
      Value: this.totalDamaged.toString(),
      OnClick: () => this.filterContainers("Damaged")
    };
    items.push(damaged);

    let available: SummaryDataItemModel = {
      Title: "Available" + (this.currentFilter == "Available" && this.locationId ? ' *' : ''),
      Value: this.totalAvailable.toString(),
      OnClick: () => this.filterContainers("Available")
    };
    items.push(available);

    if (!this.selectedDamageStatus) {
      let required: SummaryDataItemModel = {
        Title: "Required",
        Value: this.totalRequired.toString()
      };
      items.push(required);
  
      let netSurplus: SummaryDataItemModel = {
        Title: "Surplus",
        Value: this.totalNetSurplus.toString()
      };
      items.push(netSurplus);
    }

    return items;
  }

  filterContainers(filter: string) {
    this.currentFilter = filter;
    this.getContainers();
    this.summaryData = this.getSummaryData();
  }

  getRegionId(selectedRegionId) {
    if (!selectedRegionId) {
      return null;
    }

    return selectedRegionId;
  }

  getDepotId(selectedDepotId) {
    if (!selectedDepotId) {
      return null;
    }

    return selectedDepotId;
  }

  getLocationId(selectedLocationId) {
    if (!selectedLocationId) {
      return null;
    }

    return selectedLocationId;
  }

  getDamageStatus(selectedDamageStatus: string) {
    if (!selectedDamageStatus) {
      return null;
    }

    if (selectedDamageStatus == DamageStatus[DamageStatus.Damaged]) {
      return ContainerStatus.Damaged;
    }

    if (selectedDamageStatus == DamageStatus[DamageStatus.DamagedInService]) {
      return ContainerStatus.DamagedInService;
    }

    return ContainerStatus.InService;
  }

  getShowSetting(selectedShowSetting: string) {
    if (!selectedShowSetting) {
      return ContainerAvailabilityShow.All;
    }

    if (selectedShowSetting == ShowSetting[ShowSetting.Surplus]) {
      return ContainerAvailabilityShow.Surplus;
    }

    return ContainerAvailabilityShow.Deficit;
  }  

  getAssetTypeClassification(selectedVehicleType: string) {
    return !selectedVehicleType ? AssetTypeClassification.All : VehicleTypeHelper.ConvertVehicleTypeNameToAssetTypeClassification(selectedVehicleType)
  }

  regionChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("depot-details-selectedRegionId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("depot-details-selectedRegionId");
    }

    this.selectedDepotId = null;
    this.sessionStorageService.removeItem("depot-details-selectedDepotId");    
    this.getData();
  }

  depotChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("depot-details-selectedDepotId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("depot-details-selectedDepotId");
    }

    this.getData();
  }

 locationChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("depot-details-selectedLocationId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("depot-details-selectedLocationId");
    }

    this.getData();
  }

  damageStatusChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("depot-details-selectedDamageStatus", newValue);
    }
    else {
      this.sessionStorageService.removeItem("depot-details-selectedDamageStatus")
    }

    this.getData();
  }

 showSettingChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("depot-details-selectedShowSetting", newValue);
    }
    else {
      this.sessionStorageService.removeItem("depot-details-selectedShowSetting")
    }

    this.damageStatusChange("");
  }  

  selectedVehicleTypeValueChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(newValue));
    }
    else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType");
    }

    this.selectedVehicleType = newValue;
    this.getData();    
  }
  
  containerChange(newValue) {
    if (newValue) {
      this.selectedContainerId = newValue;
    } else {
      this.selectedContainerId = null;
    }

    this.filterClientSide(null);
  }

  typeChange(newValue) {
    if (newValue) {
      this.selectedContainerTypeId = newValue;
    } else {
      this.selectedContainerTypeId = null;
    }    

    this.filterClientSide(null);
  }

  statusChange(newValue) {
    if (newValue) {
      this.selectedStatusId = newValue;
    } else {
      this.selectedStatusId = null;
    }
    console.log(newValue)

    this.filterClientSide(null);
  }

  toggleRow(category) {
    if (this.expandedCategories.includes(category)) {
      const index = this.expandedCategories.indexOf(category);
      if (index > -1) {
        this.expandedCategories.splice(index, 1);
      }
    } else {
      this.expandedCategories.push(category);
    }
  }

  toggleDamage(id) {
    if (this.expandedDamage.includes(id)) {
      const index = this.expandedDamage.indexOf(id);
      if (index > -1) {
        this.expandedDamage.splice(index, 1);
      }
    } else {
      this.expandedDamage.push(id);
    }
  }

  openPopup(imageSrc: string): void {
    this.selectedImage = imageSrc;
    this.isPopupOpen = true;
  }

  closePopup(): void {
    this.isPopupOpen = false;
  }
  
  splitByCapitalLetters(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

}